var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderPnc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 8.625V8C0.875 7.50272 1.07254 7.02581 1.42417 6.67417C1.77581 6.32254 2.25272 6.125 2.75 6.125H15.25C15.7473 6.125 16.2242 6.32254 16.5758 6.67417C16.9275 7.02581 17.125 7.50272 17.125 8V8.625M9.88333 3.25833L8.11667 1.49167C8.0006 1.37546 7.86278 1.28327 7.71107 1.22035C7.55936 1.15744 7.39674 1.12504 7.2325 1.125H2.75C2.25272 1.125 1.77581 1.32254 1.42417 1.67417C1.07254 2.02581 0.875 2.50272 0.875 3V13C0.875 13.4973 1.07254 13.9742 1.42417 14.3258C1.77581 14.6775 2.25272 14.875 2.75 14.875H15.25C15.7473 14.875 16.2242 14.6775 16.5758 14.3258C16.9275 13.9742 17.125 13.4973 17.125 13V5.5C17.125 5.00272 16.9275 4.52581 16.5758 4.17417C16.2242 3.82254 15.7473 3.625 15.25 3.625H10.7675C10.4361 3.62471 10.1175 3.49282 9.88333 3.25833Z",
    stroke: "url(#paint0_linear_31_15155)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_15155",
    x1: 9,
    y1: 1.125,
    x2: 9,
    y2: 14.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPnc);
export default __webpack_public_path__ + "static/media/folderPnc.f3093eb58258ccb15351dce2029e4f6f.svg";
export { ForwardRef as ReactComponent };